import { render } from "./AIErrorNotification.vue?vue&type=template&id=2a523ed4&scoped=true"
import script from "./AIErrorNotification.vue?vue&type=script&lang=js"
export * from "./AIErrorNotification.vue?vue&type=script&lang=js"

import "./AIErrorNotification.vue?vue&type=style&index=0&id=2a523ed4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a523ed4"]])

export default __exports__